import React, { useCallback, useEffect, useRef, useState } from "react";
import classes from './padlocksList.module.css'
import DataManager from "../../hooks/DataManager";
import ListCard from "../../components/GridList/ListCard";
import BasicTable from "../../components/Table/Table/Table";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import { useDispatch, useSelector } from 'react-redux';
import Button1 from "../../components/UI/Button/Button1";
import { Await, Link, useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import useSetCookie from "../../components/hooks/UseSetCookie";
import { serviceActions } from "../../store/service-Slice";
import SearchBar from "../SearchView/Search/SearchBar";
import { getGroups, updateLockDetails } from "../../Api Methods/Api";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import DropdownCustom from '../../components/forms/DropdownCreateGroup'
import Modal from "../../components/Modal/Modal";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import PadlocksSearchbar from "./padlocksSearchBar";
import { Button } from "primereact/button";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import SelectGroupDialog from "../../components/CustomDropDown/SelectGroupDialog";

const PadlocksList = ({ locks, filtering, update, setUpdate, isSensors, isKeyboxes, isGateways }) => {

    const [iglooLocks, setPadlocks] = useState(locks);
    console.log(locks)
    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const apiData = { token, client }
    const dataManager = new DataManager();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [checkedItemsSet, setCheckedItemsSet] = useState(new Set());
    const [showMassSettings, setShowMassSettings] = useState(false)
    const [selectedMassAction, setSelectedMassAction] = useState("")
    const ModalDialog = useRef();
    const [modalTitle, setModalTitle] = useState("title")
    const [modalComponent, setModalComponent] = useState()
    const [selectAll, setSelectAll] = useState(false)
    const [filteredData, setFilteredData] = useState(locks)
    const [groupNames, setGroupNames] = useState([])
    const [selectedGroup, setSelectedGroup] = useState("")
    const [newStatus, setNewStatus] = useState("")
    const [changeBillable, setChangeBillable] = useState(false)
    const toast = useRef(null);
    const companyName = useSelector(state => state.auth.companyName);
    console.log(companyName)

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOwnedByGroupFilter, setSelectedOwnedByGroupFilter] = useState([])
    const [selectedUsedByGroupFilter, setSelectedUsedByGroupFilter] = useState([])
    const [selectedBilledToGroupFilter, setSelectedBilledToGroupFilter] = useState([])
    const [selectedFilter, setSelectedFilter] = useState("")
    const [sortBy, setSortBy] = useState([])
    const [portalSiteNameFilter, setPortalSiteNameFilter] = useState("")
    const [includes, setIncludes] = useState(true)
    const [refresh, setRefresh] = useState(0)
    const [unlinkedOnly, setUnlinkedOnly] = useState(false)

    const [showSelectBilledToDialog, setShowSelectBilledToDialog] = useState(false)
    const [showSelectOwnerDialog, setShowSelectOwnerDialog] = useState(false)
    const [showDeselect, setShowDeselect] = useState(false)

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        setSelectedMassAction("")
    } 

    useEffect(() => {
        console.log()
        let filtered = [...locks]

        console.log(locks)

        console.log(selectedBilledToGroupFilter)
        console.log(selectedOwnedByGroupFilter)
        console.log(selectedUsedByGroupFilter)
        console.log(selectedFilter)
        console.log(sortBy)
        console.log(portalSiteNameFilter)
        console.log(includes)


        if (selectedBilledToGroupFilter.length > 0){
            filtered = filtered.filter(lock => selectedBilledToGroupFilter.includes(lock.billedToName));
        }

        if (selectedOwnedByGroupFilter.length > 0){
            filtered = filtered.filter(lock => selectedOwnedByGroupFilter.includes(lock.ownedByName));
        }

        if (selectedUsedByGroupFilter.length > 0){
            filtered = filtered.filter(lock => selectedUsedByGroupFilter.includes(lock.name));
        }

        if (sortBy.length > 0){
            console.log(sortBy)
            console.log(filtered)
            if (sortBy.includes("Battery level desc")) {
                if (isGateways){
                    filtered = filtered
                        .sort((a, b) => b.battery - a.battery); 
                        console.log(filtered)
                } else {
                    filtered = filtered
                        .filter(lock => typeof lock.battery === "number")
                        .sort((a, b) => b.battery - a.battery); // highest battery first
                }
            }

            if (sortBy.includes("Battery level asc")) {
                if (isGateways){
                    filtered = filtered
                        .sort((a, b) => a.battery - b.battery); // lowest battery first
                } else {
                    filtered = filtered
                        .filter(lock => typeof lock.battery === "number")
                        .sort((a, b) => a.battery - b.battery); // lowest battery first
                }
            }

            if (sortBy.includes("Last read (newest -> oldest)")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.lastSeenAt)
                        .sort((a, b) => new Date(b.lastSeenAt) - new Date(a.lastSeenAt)); // newest first
                } else {
                    filtered = filtered
                        .filter(lock => lock.batteryReadAt)
                        .sort((a, b) => new Date(b.batteryReadAt) - new Date(a.batteryReadAt)); // newest first
                }
                
            }

            if (sortBy.includes("Last read (oldest -> newest)")) {
                 if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.lastSeenAt)
                        .sort((a, b) => new Date(a.lastSeenAt) - new Date(b.lastSeenAt)); // newest first
                } else {
                    filtered = filtered
                        .filter(lock => lock.batteryReadAt)
                        .sort((a, b) => new Date(a.batteryReadAt) - new Date(b.batteryReadAt)); // oldesr first
                }
            }

            if (sortBy.includes("Registered (oldest -> newest)")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.dateAdded)
                        .sort((a, b) => new Date(a.dateAdded) - new Date(b.dateAdded)); // oldesr first
                } else {
                    filtered = filtered
                        .filter(lock => lock.registerDate)
                        .sort((a, b) => new Date(a.registerDate) - new Date(b.registerDate)); // oldesr first
                }
            }

            if (sortBy.includes("Registered (newest -> oldest)")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.dateAdded)
                        .sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)); // oldesr first
                } else {
                    filtered = filtered
                        .filter(lock => lock.registerDate)
                        .sort((a, b) => new Date(b.registerDate) - new Date(a.registerDate)); // oldesr first
                }
            }

            if (sortBy.includes("Owner A-Z")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.name) // keeps only locks with a name
                        .sort((a, b) => a.name.localeCompare(b.name)); // Z → A
                } else {
                    filtered = filtered
                        .filter(lock => lock.ownedByName) // keeps only locks with a name
                        .sort((a, b) => a.ownedByName.localeCompare(b.ownedByName)); // Z → A
                }
            }

            if (sortBy.includes("Owner Z-A")) {
                if (isGateways) {
                    filtered = filtered
                        .filter(lock => lock.name) // keeps only locks with a name
                        .sort((a, b) => b.name.localeCompare(a.name)); // Z → A
                } else {
                    filtered = filtered
                        .filter(lock => lock.ownedByName) // keeps only locks with a name
                        .sort((a, b) => b.ownedByName.localeCompare(a.ownedByName)); // Z → A
                }
            }

            if (sortBy.includes("Billed to A-Z")) {
                filtered = filtered
                    .filter(lock => lock.billedToName) // keeps only locks with a name
                    .sort((a, b) => a.billedToName.localeCompare(b.billedToName)); // Z → A
            }

            if (sortBy.includes("Billed to Z-A")) {
                filtered = filtered
                    .filter(lock => lock.billedToName) // keeps only locks with a name
                    .sort((a, b) => b.billedToName.localeCompare(a.billedToName)); // Z → A
            }

            if (sortBy.includes("Used by A-Z")) {
                filtered = filtered
                    .filter(lock => lock.name) // keeps only locks with a name
                    .sort((a, b) => a.name.localeCompare(b.name)); // Z → A
            }

            if (sortBy.includes("Used by Z-A")) {
                filtered = filtered
                    .filter(lock => lock.name) // keeps only locks with a name
                    .sort((a, b) => b.name.localeCompare(a.name)); // Z → A
            }
        }

        if (selectedFilter.length > 0){
            if (selectedFilter.includes("Billable")){
                filtered = filtered.filter(lock => lock.billable == 1);
            }
            if (selectedFilter.includes("Not billable")){
                filtered = filtered.filter(lock => lock.billable == 0);
            }
        }

        if (searchTerm !== ""){
            filtered = filtered.filter((item) =>
                Object.values(item)
                .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
            );
        
            dataManager.setItem('padlocksSearchTerm', searchTerm)
        }

        if (unlinkedOnly){
            filtered = filtered.filter(lock => lock.pinName == "Not Linked");
        }

        setFilteredData(filtered)
        console.log(filtered)

    }, [selectedOwnedByGroupFilter, selectedUsedByGroupFilter, selectedBilledToGroupFilter, selectedFilter, searchTerm, sortBy, portalSiteNameFilter, includes, refresh, unlinkedOnly])

    const exportToExcel = () => {

        const excludeColumns = [
            "uuid", 
            "relationshipPin", 
            "ownedByGID", 
            "billedToGID",
            "deviceName"
        ]

        const columnMap = {
            key: 'Site ID',
            name: 'Used by',
            tag: "Portal site name",
            lockID: "Lock ID",
            battery: 'Battery %',
            batteryReadAt: 'Last Read',
            lockName: "Lock S/N",
            billedToName: "Billed to",
            ownedByName: "Owned by",
            pinName: "Output name",
            billable: "Billable"
        };

        const filtered = filteredData.map(item => {
            const newItem = {};
            Object.keys(item).forEach(key => {
                if (!excludeColumns.includes(key)) {
                    const newKey = columnMap[key] || key;
                    let value = item[key];

                    if (key === 'batteryReadAt' && value) {
                        value = new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
                    }

                    newItem[newKey] = value;
                }
            });
            return newItem;
        });


        const worksheet = XLSX.utils.json_to_sheet(filtered);        
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Locks');

        // Write the workbook to a binary array
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        // Create a Blob with the correct MIME type for Excel
        const blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        // Save file with .xlsx extension
        saveAs(blob, `locks.xlsx`);
    };


    const HandleUipiodOnClick = (DeviceUUID) => {
        console.log(DeviceUUID)
        if (DeviceUUID){
            dispatch(serviceActions.setDeviceUUID(DeviceUUID));
            navigate("/Dashboard/SiteView/" + DeviceUUID); 
        }
        useSetCookie("DeviceUUID", DeviceUUID, 1);
    }

    const HandlePadlockOnClick = (lockID) => {
        console.log("here")
        if (lockID) {
            dispatch(serviceActions.setLockID(lockID));
            navigate("/Dashboard/Padlocks/Lock/" + lockID); 
        }
        useSetCookie("LockID", lockID, 1);
    }


    const [groups, setGroups] = useState([])

    useEffect(() => {
        const GetGroups = async () => {
            const groups = await getGroups(apiData, dispatch)
            setGroups(groups)
            setGroupNames(groups.map(listOptions => listOptions.name))
            console.log(groups)
        }

        GetGroups();
    }, [])
    

    const HandleGroupOnClick = (groupName) => {

        const groupClicked = groups.find(g => g.name === groupName);

        if (groupClicked) {
            sessionStorage.setItem('groupClicked', groupClicked.name)   
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)   
            navigate("/Dashboard/Groups/GroupSites")
        }
    }

    const batteryColours = (batteryLevel) => {
        let colour = "";
        if (batteryLevel > 0 && batteryLevel < 25) {
            // red
            colour = "rgb(220,114,119)"
        } else if (batteryLevel >= 25 && batteryLevel < 50) {
            //orange
            colour = "rgb(248,183,131)"
        } else if (batteryLevel >= 50){
            //green
            colour = "rgb(101,151,100)"
        } else {
            colour = "rgba(145, 145, 145, 1)"
        }

        return colour;
    }

    const handleCheckboxChange = (lockID) => {
        setCheckedItemsSet(prev => {
            const newSet = new Set(prev);
            if (newSet.has(lockID)) {
                newSet.delete(lockID);
            } else {
                newSet.add(lockID);
            }
            return newSet;
        });
    };

    useEffect(() => {
        if (checkedItemsSet.size > 0) {
            setShowMassSettings(true)
            setShowDeselect(true)
        } else {
            setShowMassSettings(false)
            setShowDeselect(false)
        }
    }, [checkedItemsSet])

    const HandleDeselect = () => {
        checkedItemsSet.clear();
        setCheckedItemsSet(new Set());
    }


    // const HandleUpdateBilledTo = () => {
    //     setModalTitle("Update billed to")

    //     setModalComponent(
    //     <div>
    //         <br></br>
    //         <DropdownCustom label={"Please select a group below"} dropDownOptions={groupNames.sort((a, b) => a.localeCompare(b))} setSelectedGroup={setSelectedGroup} />
    //         <br></br>
    //         <Button1 onClick={() => massUpdateBilledTo()}>Update</Button1>
    //     </div>

    //     )
    //     HandleShowModal();
    // }

    // const HandleUpdateOwnedBy = () => {
    //     setModalTitle("Update owner")
    //     setModalComponent(
    //     <div>
    //         <br></br>
    //         <Dropdown 
    //             onChange={(e) => setSelectedGroup(e.value)} 
    //             options={groupNames.sort((a, b) => a.localeCompare(b))} 
    //             optionLabel="name" 
    //             placeholder="Select a group" 
    //             filter 
    //             className="w-full md:w-14rem" 
    //             appendTo={document.getElementById('root')}
    //         />

    //         {/* <DropdownCustom label={"Please select a group below"} dropDownOptions={groupNames.sort((a, b) => a.localeCompare(b))} setSelectedGroup={setSelectedGroup} /> */}
    //         <br></br>
    //         <Button1 onClick={() => massUpdateOwnedBy()}>Update</Button1>
    //     </div>
    //     )
    //     HandleShowModal();
    // }

    const HandleUpdateBillable = () =>{
        setChangeBillable(true)
    }

    const HandleSelectAll = () => {
        setSelectAll(!selectAll)
    }
    
    useEffect(() => {
        setCheckedItemsSet(prev => {
            const newSet = new Set(prev);
            if (selectAll){
                for (const lock of filteredData){
                    newSet.add(lock.lockID)
                }
            } else {
                newSet.clear();
            }
            return newSet;
        });
    }, [selectAll])

    useEffect(() => {
        console.log(selectedMassAction)
        switch (selectedMassAction) {
            case "Update billed to": {
                //HandleUpdateBilledTo()
                setShowSelectBilledToDialog(true)
                setSelectedMassAction("")
                break;
            }
            case "Update owned by": {
                //HandleUpdateOwnedBy()
                setShowSelectOwnerDialog(true)
                setSelectedMassAction("")
                break;
            }
            case "Update billable": {
                HandleUpdateBillable()
                setSelectedMassAction("")
                break;
            }
        }
    }, [selectedMassAction])

    const signalColours = (signal) => {
        let colour = "";
        if (signal >= 0 && signal < 25) {
            // red
            colour = "rgb(220,114,119)"
        } else if (signal >= 25 && signal < 50) {
            //orange
            colour = "rgb(248,183,131)"
        } else {
            //green
            colour = "rgb(101,151,100)"
        }

        return colour;

    }

    let keyboxTableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <div style={{ marginRight: "10px" }}>
                        <Checkbox
                            onChange={e => HandleSelectAll()}
                            checked={selectAll == true}>
                        </Checkbox>
                    </div>
                    <h3>Keybox ID</h3>
                </div> 
            ),
            accessorKey: 'lockID',
            cell: (row) => (
            <div style={{ display: 'flex', alignItems: 'center', marginRight: "10px"}}>
                <CheckboxCell
                    lockID={row.row.original.lockID}
                    checked={checkedItemsSet.has(row.row.original.lockID)}
                    onChange={handleRowCheckbox(row.row.original.lockID)}
                />
               <Link
                    to={`/Dashboard/Padlocks/Lock/${row.row.original.lockID}`}
                    className={classes.tableValueText}
                    style={{marginLeft: "10px" }}
                >
                    {row.row.original.lockID}
                </Link>
            </div>
            )
        },
        // {
        //     header: () => (
        //         <div className={classes.tableTitleText} title="Click to sort">
        //             <h3>Keybox name  </h3>
        //         </div> 
        //     ),
        //     accessorKey: 'lockName',
        //     cell: (row) => {
        //         return (
        //             <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueTextBold}>
        //                 {row.row.original.lockName || ""}
        //             </div>
        //         )
        //     }
        // },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Linked output  </h3>
                </div> 
            ),
            accessorKey: 'pinName',
            cell: (row) => {
                return (
                    <div className={classes.tableValueText}>
                        {row.row.original.pinName && row.row.original.pinName.trim() !== "Not Linked" ? (
                            <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
                                {row.row.original.pinName}
                            </div>
                        ) : <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#fa5d5dff"}
                                PillColor_IfFalse={"#fa5d5dff"}
                                text_IfTrue={"Not linked"}
                                className={classes.PillHeight}
                            /> }                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Portal site name  </h3>
                </div>  
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#919191"}
                                PillColor_IfFalse={"#6e6e6e"}
                                text_IfTrue={row.row.original.tag}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Site ID  </h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Battery level  </h3>
                </div> 
            ),
            accessorKey: 'battery',
            cell: (row) => {
                return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        <Pill_Widget 
                        boolean={true} 
                        PillColor_IfTrue={batteryColours(row.row.original.battery)} 
                        PillColor_IfFalse={"#626a67"} 
                        text_IfTrue={row.row.original.battery !== 0 ? row.row.original.battery + "%" : "?"} 
                        className={classes.PillHeight} />
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Regsitered  </h3>
                </div> 
            ),
            accessorKey: 'registerDate',
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.registerDate)) || 
                !row.row.original.registerDate 
                  ? row.row.original.registerDate 
                  : format(new Date(row.row.original.registerDate), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Last read  </h3>
                </div> 
            ),
            accessorKey: 'batteryReadAt',
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.batteryReadAt)) || 
                !row.row.original.batteryReadAt 
                  ? row.row.original.batteryReadAt 
                  : format(new Date(row.row.original.batteryReadAt), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Used by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a67"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Owned by</h3>
            </div> 
        ),
        accessorKey: 'ownedByName',
        cell: (row) => {
            let companyName = row.row.original.ownedByName;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";
            console.log(companyName)

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.ownedByName)}>
                    <Pill_Widget
                    boolean={row.row.original.ownedByName !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.ownedByName}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Billable</h3>
                </div> 
            ),
            accessorKey: 'billable',
            cell: (row) => {
                return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        <Pill_Widget 
                        boolean={row.row.original.billable == 1} 
                        PillColor_IfTrue={"#73cf72"} 
                        PillColor_IfFalse={"#dc7277"} 
                        text_IfTrue={"Yes"}
                        text_IfFalse={"No"}
                        className={classes.PillHeight} />
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Billed to</h3>
            </div> 
        ),
        accessorKey: 'billedToName',
        cell: (row) => {
            let companyName = row.row.original.billedToName;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";
            console.log(companyName)

            return (
                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.billedToName)}>
                    <Pill_Widget
                    boolean={row.row.original.billedToName !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.billedToName}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        }
        
    ]

    let gatewayTableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>IMEI  
                    </h3>
                </div> 
            ),
            accessorKey: 'IMEI',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.IMEI}
                    </div>
                )
            }
        },
        
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Portal name</h3>
                </div>  
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#919191"}
                                PillColor_IfFalse={"#6e6e6e"}
                                text_IfTrue={row.row.original.tag}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>App name</h3>
                </div> 
            ),
            accessorKey: 'deviceName',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#C3B1E1"}
                                PillColor_IfFalse={"#626a67"}
                                text_IfTrue={row.row.original.deviceName}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Site ID</h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Battery</h3>
                </div> 
            ),
            accessorKey: 'battery',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        <Pill_Widget boolean={true} PillColor_IfTrue={batteryColours(row.row.original.battery)} PillColor_IfFalse={"#626a67"} text_IfTrue={row.row.original.battery + "%"} className={classes.PillHeight} />
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Last seen</h3>
                </div> 
            ),
            accessorKey: 'lastSeenAt',
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.lastSeenAt)) || 
                !row.row.original.lastSeenAt 
                  ? row.row.original.lastSeenAt 
                  : format(new Date(row.row.original.lastSeenAt), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Date added</h3>
                </div> 
            ),
            accessorKey: 'dateAdded',
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.dateAdded)) || 
                !row.row.original.dateAdded 
                  ? row.row.original.dateAdded 
                  : format(new Date(row.row.original.dateAdded), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
                {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Owned by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";
            console.log(companyName)

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={row.row.original.name !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        }
    ]

    let sensorTableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Sensor ID
                    </h3>
                </div> 
            ),
            accessorKey: 'deviceID',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.deviceID}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Sensor name</h3>
                </div> 
            ),
            accessorKey: 'pinName',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
                        {row.row.original.pinName}
                    </div>
                )
            }
        },
        {
            header: () => (
              <div className={classes.tableTitleText} title="Click to sort">
                <h3>Sensor type</h3>
              </div>
            ),
            accessorKey: 'sensorType',
            cell: (row) => {

                let sensorType = "";
                switch(row.row.original.sensorType){
                    case 'SIGFOX RE:SURE':
                        sensorType = "SigFox lite contact"
                    break;
                    case 'IOTA':
                        sensorType = "SigFox industrial contact"
                    break;
                    case 'KNOWIO Sensor':
                        sensorType = "NB-IOT contact"
                    break;
                    default:
                        sensorType = row.row.original.sensorType;
                    break;
                }

              return (
                <div
                  onClick={() => HandleUipiodOnClick(row.row.original.uuid)}
                  className={classes.tableValueText}
                >
                  {sensorType}
                </div>
              );
            },
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Portal site name</h3>
                </div>  
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#919191"}
                                PillColor_IfFalse={"#6e6e6e"}
                                text_IfTrue={row.row.original.tag}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Site ID</h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
              <div className={classes.tableTitleText} title="Click to sort">
                <h3>Battery level</h3>
              </div>
            ),
            accessorKey: 'battery',
            cell: (row) => {
              const batteryReadAt =
                row.row.original.battery === "Not Read Yet" || row.row.original.battery === "No Data"
                  ? "No data"
                  : row.row.original.battery + "%";
          
              return (
                <div
                  onClick={() => HandleUipiodOnClick(row.row.original.uuid)}
                  className={classes.tableValueText}
                >
                  {batteryReadAt !== "No data" ? (
                    <Pill_Widget
                      boolean={true}
                      PillColor_IfTrue={batteryColours(row.row.original.battery)}
                      PillColor_IfFalse={"#626a67"}
                      text_IfTrue={batteryReadAt}
                      className={classes.PillHeight}
                    />
                  ) : null}
                </div>
              );
            },
          },
          {
            header: () => (
              <div className={classes.tableTitleText} title="Click to sort">
                <h3>Signal strength</h3>
              </div>
            ),
            accessorKey: 'signal',
            cell: (row) => {
              const signalStrength =
                row.row.original.signal === "Not Read Yet" || row.row.original.signal === "No Data"
                  ? "No data"
                  : row.row.original.signal + "%";
          
              return (
                <div
                  onClick={() => HandleUipiodOnClick(row.row.original.uuid)}
                  className={classes.tableValueText}
                >
                  {signalStrength !== "No data" ? (
                    <Pill_Widget
                      boolean={true}
                      PillColor_IfTrue={signalColours(row.row.original.signal)}
                      PillColor_IfFalse={"#626a67"}
                      text_IfTrue={signalStrength}
                      className={classes.PillHeight}
                    />
                  ) : null}
                </div>
              );
            },
          },
          {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Owned by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a67"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        }
          
    ]

    const CheckboxCell = React.memo(({ lockID, checked, onChange }) => (
        <Checkbox onChange={() => onChange(lockID)} checked={checked} />
    ));
    const handleRowCheckbox = useCallback((lockID) => () => handleCheckboxChange(lockID), [handleCheckboxChange]);


    let tableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <div style={{ marginRight: "10px" }}>
                        <Checkbox
                            onChange={e => HandleSelectAll()}
                            checked={selectAll == true}>
                        </Checkbox>
                    </div>
                    <h3>Lock ID</h3>
                </div> 
            ),
            accessorKey: 'lockID',
            cell: (row) => (
            <div style={{ display: 'flex', alignItems: 'center', marginRight: "10px" }}>
                <CheckboxCell
                    lockID={row.row.original.lockID}
                    checked={checkedItemsSet.has(row.row.original.lockID)}
                    onChange={handleRowCheckbox(row.row.original.lockID)}
                />
                {/* <div style={{marginLeft: "10px" }} onClick={() => HandlePadlockOnClick(row.row.original.lockID)}>
                    {row.row.original.lockID}
                </div> */}

                {/* <Link
                    to={`/Dashboard/Padlocks/Lock/${row.row.original.lockID}`}
                    style={{
                    display: 'block',
                    maxWidth: '150px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    textDecoration: 'none',
                    color: 'inherit'
                    }}
                    className={classes.tableValueText}>
                </Link> */}

                <Link
                    to={`/Dashboard/Padlocks/Lock/${row.row.original.lockID}`}
                    className={classes.tableValueText}
                    style={{marginLeft: "10px" }}
                >
                    {row.row.original.lockID}
                </Link>
            </div>
            )
        },
        // {
        //     header: () => (
        //         <div className={classes.tableTitleText} title="Click to sort">
        //             <h3>Lock name
        //             </h3>
        //         </div> 
        //     ),
        //     accessorKey: 'lockName',
        //     cell: (row) => {
        //         return (
        //             <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
        //                 {row.row.original.lockName || ""}
        //             </div>
        //         )
        //     }
        // },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Linked output  </h3>
                </div> 
            ),
            accessorKey: 'pinName',
            cell: (row) => {
                return (
                    <div className={classes.tableValueText}>
                        {row.row.original.pinName && row.row.original.pinName.trim() !== "Not Linked" ? (
                            <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
                                {row.row.original.pinName}
                            </div>
                        ) : <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#fa5d5dff"}
                                PillColor_IfFalse={"#fa5d5dff"}
                                text_IfTrue={"Not linked"}
                                className={classes.PillHeight}
                            /> }                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Portal site name  </h3>
                </div>  
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div className={classes.tableValueText}>
                        {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#919191"}
                                PillColor_IfFalse={"#6e6e6e"}
                                text_IfTrue={row.row.original.tag}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Site ID  </h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Battery level  </h3>
                </div> 
            ),
            accessorKey: 'battery',
            cell: (row) => {
                return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        <Pill_Widget 
                        boolean={true} 
                        PillColor_IfTrue={batteryColours(row.row.original.battery)} 
                        PillColor_IfFalse={"#626a67"} 
                        text_IfTrue={row.row.original.battery !== 0 ? row.row.original.battery + "%" : "?"} 
                        className={classes.PillHeight} />
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Regsitered  </h3>
                </div> 
            ),
            accessorKey: 'registerDate',
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.registerDate)) || 
                !row.row.original.registerDate 
                  ? row.row.original.registerDate 
                  : format(new Date(row.row.original.registerDate), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Last read  </h3>
                </div> 
            ),
            accessorKey: 'batteryReadAt',
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.batteryReadAt)) || 
                !row.row.original.batteryReadAt 
                  ? row.row.original.batteryReadAt 
                  : format(new Date(row.row.original.batteryReadAt), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Used by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";
            console.log(companyName)

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={row.row.original.name !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Owned by</h3>
            </div> 
        ),
        accessorKey: 'ownedByName',
        cell: (row) => {
            let companyName = row.row.original.ownedByName;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";
            console.log(companyName)

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.ownedByName)}>
                    <Pill_Widget
                    boolean={row.row.original.ownedByName !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.ownedByName}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Billable</h3>
                </div> 
            ),
            accessorKey: 'billable',
            cell: (row) => {
                return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        <Pill_Widget 
                        boolean={row.row.original.billable == 1} 
                        PillColor_IfTrue={"#73cf72"} 
                        PillColor_IfFalse={"#dc7277"} 
                        text_IfTrue={"Yes"}
                        text_IfFalse={"No"}
                        className={classes.PillHeight} />
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Billed to</h3>
            </div> 
        ),
        accessorKey: 'billedToName',
        cell: (row) => {
            let companyName = row.row.original.billedToName;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";
            console.log(companyName)

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.billedToName)}>
                    <Pill_Widget
                    boolean={row.row.original.billedToName !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.billedToName}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        }
    ]


    if (isSensors) {
        tableColumns = sensorTableColumns
    };

    if (isGateways){
        tableColumns = gatewayTableColumns
    }

    if (isKeyboxes) {
        tableColumns = keyboxTableColumns
    }

    const accept = async () => {
        massUpdateBillable("1");
    }

    const reject = () => {
        massUpdateBillable("0");
    }

    const UpdateLockDetails = async (lockID, columnName, newValue) => {
        let body = {
            lockID: lockID,
            columnName: columnName,
            newValue: newValue
        }

        console.log(body)
        const response = await updateLockDetails(apiData, body, dispatch)
    }

    const updateAndNotify = (successfulLockIDs, columnName, newValue, message) => {
        setFilteredData(prevFilteredData =>
            prevFilteredData.map(lock =>
                successfulLockIDs.includes(lock.lockID)
                    ? { ...lock, [columnName]: newValue }
                    : lock
            )
        );

        const allSuccessful = successfulLockIDs.length === checkedItemsSet.size;

        if (allSuccessful) {
            toast.current.show({
                severity: 'success',
                summary: 'Confirmed',
                detail: message,
                life: 3000
            });
        } else {
            toast.current.show({
                severity: 'warn',
                summary: 'Partial failure',
                detail: `Some updates failed, please try again`,
                life: 4000
            });
        }
    }

    const massUpdateBillable = async (newStatus) => {
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (lockID) => {
                try {
                    await UpdateLockDetails(lockID, 'billable', newStatus);
                    return { lockID, success: true };
                } catch (error) {
                    return { lockID, success: false, error };
                }
            })
        );

        const successfulLockIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.lockID);

        updateAndNotify(successfulLockIDs, "billable", newStatus, "Billing status updated")
    }

    const massUpdateOwnedBy = async (value) => {
        //HandleCloseModal();
        const groupObj = groups.find(g => g.name === value);
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (lockID) => {
                try {
                    await  UpdateLockDetails(lockID, 'ownedByGID', groupObj.id)
                    return { lockID, success: true };
                } catch (error) {
                    return { lockID, success: false, error };
                }
            })
        );

        const successfulLockIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.lockID);

        updateAndNotify(successfulLockIDs, "ownedByName", value, "Owner updated")
    }

    const massUpdateBilledTo = async (value) => {
        const groupObj = groups.find(g => g.name === value);
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (lockID) => {
                try {
                    await  UpdateLockDetails(lockID, 'billedToGID', groupObj.id)
                    return { lockID, success: true };
                } catch (error) {
                    return { lockID, success: false, error };
                }
            })
        );

        const successfulLockIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.lockID);

        updateAndNotify(successfulLockIDs, "billedToName", value, "Billable updated")
    }

    const massActionOptions = companyName == "EyeSpyFX" || companyName == "Knowio" ? [
        "Update billed to",
        "Update owned by",
        "Update billable"
    ] : ["Update owned by"]

    const defaultConfirmProps = {
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Billable',
        rejectLabel: 'Not billable',
        defaultFocus: 'accept',
        accept,
        reject,
    };

    useEffect(() => {
        setFilteredData(locks.filter((item) =>
            Object.values(item)
                .some(value => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
        ));
    }, [searchTerm])

    return (
        <>
        <Toast ref={toast} />

        <Modal ref={ModalDialog} title={modalTitle} modalName={"Update"} HandleShowModal={HandleShowModal}>
            {modalComponent}
        </Modal>

        {showSelectBilledToDialog && (
            <SelectGroupDialog
                title = {"Select the group to be billed"}
                visible={showSelectBilledToDialog}
                onHide={() => setShowSelectBilledToDialog(false)}
                groupNames={groupNames}
                functionToCall={(selectedGroup) => {
                    massUpdateBilledTo(selectedGroup);   // call your existing function
                }}
            />
        )}

        {showSelectOwnerDialog && (
            <SelectGroupDialog
                title = {"Select the new owner"}
                visible={showSelectOwnerDialog}
                onHide={() => setShowSelectOwnerDialog(false)}
                groupNames={groupNames}
                functionToCall={(selectedGroup) => {
                    massUpdateOwnedBy(selectedGroup);   // call your existing function
                }}
            />
        )}

        <ConfirmDialog
                visible={changeBillable}
                onHide={() => setChangeBillable(false)}
                {...defaultConfirmProps}
                message={`Update padlock billing status to:`}
        />
    
        <div className={`${classes.table} ${classes.center} `}>
            <ListCard secondaryClassName={classes["Card-container"]}>
                <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "5px 10px 0px 10px" }}>
                    <Await resolve={locks}>
                        {(loadedtableData) => {
                            return (
                                <>
                                    {/* Search bar */}
                                    <div className={classes.searchContainer}>
                                        {/* <SearchBar
                                            type="text"
                                            placeholder="Search..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            style={{
                                                
                                                padding: "5px 8px", // Adjust padding to reduce height
                                                width: "300px",    // Set a specific width
                                                fontSize: "14px",  // Adjust font size for better proportions
                                                boxSizing: "border-box", // Ensure consistent sizing
                                                borderRadius: "4px", // Add slight rounding for aesthetics
                                                border: "1px solid #ccc" // Define a subtle border
                                            }}
                                        />
                                     */}

                                     {/* <div>
                                                                                <Button onClick={() => exportToExcel(filteredData, "filteredLocks")}>Export to Excel</Button>

                                     </div> */}

                                     <PadlocksSearchbar
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        showFilterButton={true}
                                        groups={groups}
                                        selectedOwnedByGroupFilter={selectedOwnedByGroupFilter}
                                        setSelectedOwnedByGroupFilter={setSelectedOwnedByGroupFilter}
                                        selectedUsedByGroupFilter={selectedUsedByGroupFilter}
                                        setSelectedUsedByGroupFilter={setSelectedUsedByGroupFilter}
                                        selectedBilledToGroupFilter={selectedBilledToGroupFilter}
                                        setSelectedBilledToGroupFilter={setSelectedBilledToGroupFilter}
                                        selectedFilter={selectedFilter}
                                        setSelectedFilter={setSelectedFilter}
                                        sortBy={sortBy}
                                        setSortBy={setSortBy}
                                        portalSiteNameFilter={portalSiteNameFilter}
                                        setPortalSiteNameFilter={setPortalSiteNameFilter}
                                        includes={includes}
                                        setIncludes={setIncludes}
                                        style={{
                                            padding: "10px", 
                                            width: "300px",    
                                            fontSize: "14px",  
                                            boxSizing: "border-box", 
                                            borderRadius: "4px",
                                        }}
                                        handleExport={exportToExcel}
                                        unlinkedOnly={unlinkedOnly}
                                        setUnlinkedOnly={setUnlinkedOnly}
                                        isGateways={isGateways}/>

                                        <p style={{ marginLeft: "15px", marginBottom: 0 }}>
                                            Total results: {filteredData.length}
                                        </p>

                                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                                            {showMassSettings && (
                                                <Dropdown
                                                value={selectedMassAction}
                                                onChange={(e) => setSelectedMassAction(e.value)}
                                                options={massActionOptions}
                                                placeholder="Select an action"
                                                className="w-full md:w-14rem"
                                                />
                                            )}

                                            {showDeselect && (
                                                <Button
                                                severity="danger"
                                                style={{ marginTop: 0 }}
                                                label={`Deselect ${checkedItemsSet.size} sites`}
                                                icon="pi pi-times"
                                                outlined
                                                onClick={HandleDeselect}
                                                />
                                            )}
                                            </div>
                                    </div>
                                    
                                
                                    {/* Table */}
                                    <BasicTable
                                        data={filteredData}
                                        columns={tableColumns}
                                        filtering={filtering}
                                        rowClick={false}
                                        ShowPagination={false}
                                        PageSize={5000}
                                        paginationOptions={[25, 50, 100]}
                                        showFilterButton={false}
                                        isSortable={false}
                                    />
                                </>
                            );
                        }}
                    </Await>
                </div>
            </ListCard>
        </div>
        </>
    );
}

export default PadlocksList;